import { API_DOMAIN } from "../constants";

// ── API endpoints ────────────────────────────────────────────────────────────
export const CHAT_API          = API_DOMAIN + "/wati_messages/fetch_messages";
export const CHAT_V2_API       = API_DOMAIN + "/wati_messages/fetch_messages_v2";
export const CHAT_FILTERS_API  = API_DOMAIN + "/wati_messages/get_chat_filters";
export const CHAT_MESSAGES_API = API_DOMAIN + "/wati_messages/fetch_specific_chat_messages";
export const SEND_VOICE_API    = API_DOMAIN + "/wati_messages/send_voice_message";
export const SEND_IMAGE_API    = API_DOMAIN + "/wati_messages/send_image_message";
export const SEND_VIDEO_API    = API_DOMAIN + "/wati_messages/send_video_message";
export const SEND_DOCUMENT_API = API_DOMAIN + "/wati_messages/send_document_message";
export const SEND_TEXT_API     = API_DOMAIN + "/wati_messages/send_text_message";
export const SEND_TEMPLATE_API = API_DOMAIN + "/wati_messages/send_template";
export const MARK_AS_READ_API  = API_DOMAIN + "/wati_messages/mark_chat_as_read";

// ── File upload rules ────────────────────────────────────────────────────────
export const MB = 1024 * 1024;
export const KB = 1024;

// Extension list and caps reconstructed from what WATI's own attachment
// picker actually accepts (their public docs were wrong) — no separate
// "sticker" bucket, since we never send stickers, only display incoming
// ones; webp is just a normal image here, matching WATI's own picker.
// Images have no cap since they're always compressed (browser-image-
// compression, maxSizeMB: 4) before being sent through the chunk-upload
// flow. Everything else is capped at a conservative 15,000,000 bytes —
// checked against the original File.size, before Base64 conversion, since
// Base64 adds ~33% for transport but WATI validates the reconstructed
// binary file, not the wire size.
export const WATI_MAX_MEDIA_BYTES = 15_000_000;

export const WATI_FILE_RULES = {
  "image/jpeg": { category: "image",    maxBytes: Infinity, label: "JPEG" },
  "image/png":  { category: "image",    maxBytes: Infinity, label: "PNG" },
  // webp deliberately excluded — WATI's own picker lets you select it, but
  // rejects the send immediately after, every time. Their oversight, not
  // ours; matching it here means we reject it too instead of letting staff
  // hit a guaranteed dead end.
  "video/mp4":    { category: "video", maxBytes: WATI_MAX_MEDIA_BYTES, label: "MP4" },
  "video/3gpp":   { category: "video", maxBytes: WATI_MAX_MEDIA_BYTES, label: "3GP" },
  "video/x-m4v":  { category: "video", maxBytes: WATI_MAX_MEDIA_BYTES, label: "M4V" },
  "audio/aac":  { category: "audio", maxBytes: WATI_MAX_MEDIA_BYTES, label: "AAC" },
  "audio/mp4":  { category: "audio", maxBytes: WATI_MAX_MEDIA_BYTES, label: "M4A" },
  "audio/mpeg": { category: "audio", maxBytes: WATI_MAX_MEDIA_BYTES, label: "MP3" },
  "audio/amr":  { category: "audio", maxBytes: WATI_MAX_MEDIA_BYTES, label: "AMR" },
  "audio/ogg":  { category: "audio", maxBytes: WATI_MAX_MEDIA_BYTES, label: "OGG" },
  "audio/opus": { category: "audio", maxBytes: WATI_MAX_MEDIA_BYTES, label: "Opus" },
  "application/pdf":   { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "PDF" },
  "application/msword": { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "DOC" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":   { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "DOCX" },
  "application/vnd.ms-powerpoint":  { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "PPT" },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "PPTX" },
  "application/vnd.ms-excel":  { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "XLS" },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "XLSX" },
  "text/plain":       { category: "document", maxBytes: WATI_MAX_MEDIA_BYTES, label: "TXT" },
};

export const WATI_ACCEPT_ATTR  = Object.keys(WATI_FILE_RULES).join(",");
export const WATI_ACCEPT_LABEL = "Images: JPEG, PNG (no size limit) · Videos: MP4, 3GP, M4V (15 MB) · Audio: AAC, M4A, MP3, AMR, OGG, Opus (15 MB) · Docs: PDF, Word, Excel, PowerPoint, TXT (15 MB)";

// ── Ticket status display config ─────────────────────────────────────────────
export const TICKET_STATUS = {
  0: { label: "Unassigned", color: "#cf1322", bg: "#fff1f0", border: "#ff4d4f" },
  1: { label: "Open",       color: "#389e0d", bg: "#f6ffed", border: "#52c41a" },
  2: { label: "Solved",     color: "#0958d9", bg: "#e6f4ff", border: "#91caff" },
  3: { label: "Pending",    color: "#d46b08", bg: "#fff7e6", border: "#ffa940" },
  4: { label: "Expired",    color: "#d48806", bg: "#fffbe6", border: "#ffe58f" },
};

export const TICKET_STATUS_STRING = { 0: "Open", 1: "Open", 2: "Solved", 3: "Pending", 4: "Expired" };

// ── Google Maps ──────────────────────────────────────────────────────────────
export const GMAPS_KEY  = "AIzaSyCKT6hm3CTWMFr56LLdsXUjlZpFHY6ihUs";
export const GMAPS_LIBS = ["places"];
